import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {LanguageAssignments} from '@emm/core/models/language-assignments.model';
import {standardRetry} from '@emm/core/util/rx.util';

@Injectable({
  providedIn: 'root'
})
export class LanguageAssignmentsService {

  constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) { }

  public getLanguageAssignment(location: any): Observable<LanguageAssignments> {
    return this.http.get(`${this.apiUrl}/locations/languages/${location}`).pipe(
      map((response: any) => response),
      standardRetry()
    );
  }

    // same method for create and update
  public saveLanguageAssignment(languageAssignment: LanguageAssignments): Observable<LanguageAssignments> {
    return this.http
      .post(`${this.apiUrl}/locations/languages`, languageAssignment)
      .pipe(standardRetry());
  }
}
